import { useSearchParams, Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, ArrowRight, CircleAlert } from 'lucide-react';

import { AuthSplitLayout } from '@/components/layout/AuthSplitLayout';
import { Button } from '@agion/ui';

export function VerificationFailedPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error') || t('emailVerification.genericError', 'Verification failed');

  return (
    <AuthSplitLayout>
      <div className="lp-state lp-pop" role="alert">
        <div className="lp-badge lp-badge-brand">
          <CircleAlert size={24} aria-hidden="true" />
        </div>
        <h2 className="lp-state-title">
          {t('emailVerification.failedTitle', 'Verification Failed')}
        </h2>
        <p className="lp-state-msg">{decodeURIComponent(error)}</p>
        <p className="lp-note">
          {t('emailVerification.failedDescription', 'Your verification link may have expired. Please register again to receive a new verification email.')}
        </p>
        <hr className="lp-state-divider" />

        <Button asChild className="lp-btn-primary w-full">
          <Link to="/register">
            {t('emailVerification.registerAgain', 'Register Again')}
            <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </Button>

        <Link to="/login" className="lp-back">
          <ArrowLeft size={16} aria-hidden="true" />
          {t('backToLogin', 'Back to Login')}
        </Link>
      </div>
    </AuthSplitLayout>
  );
}

export default VerificationFailedPage;
